import { IUserService } from '../../../User/types';
import { Cancellable } from '@infrastructure/axios';
import { IInvoiceProfile, InvoiceProfileWithBankInfo } from '../../types';

export default class GetInvoiceProfileUseCase extends Cancellable {
  constructor(private service: IInvoiceProfile, private userService: IUserService) {
    super();
    this.service = service;
    this.userService = userService;
  }

  public async execute(): Promise<InvoiceProfileWithBankInfo> {
    const invoiceProfile = await this.service.getInvoiceProfile(this.controller);
    const bankData = await this.userService.getUserBankInfo(this.controller);
    const response = {   userBanking: bankData,invoiceProfile: invoiceProfile,}
    return response

  }
}
